import { createReducer, on, Action } from '@ngrx/store';
import { addToCar, modifyProduct, removeToCar, modifyTokenProduct } from '../actions/carCheckout.actions';
import { ProductCar } from 'src/app/models/productCar.model';

export const initialState: ProductCar[] = [

];

const _carCheckoutReducer = createReducer(initialState,
  on( addToCar, (state, { product }) => [...state, product ] ),
  on ( removeToCar, ( state, { id } ) =>  state.filter( product => product.id !== id ) ),
  on( modifyProduct, (state, { id, count }) => {
    return state.map( product => {
      if ( product.id === id  ) {
        return {
          ...product,
          external_product_id : Date.now().toString(),
          totalPrice : product.priceDiscount * count,
          quantity : count,
        }
      } else {
        return product;
      }
    });
  }),
  on( modifyTokenProduct, (state, { id, token }) => {
    return state.map( product => {
      if ( product.id === id  ) {
        return {
          ...product,
          token
        }
      } else {
        return product;
      }
    });
  }),
);


export function carCheckoutReducer(state: ProductCar[] | undefined, action: Action) {
    return _carCheckoutReducer(state, action);
}
